import Page from "src/components/Report/Page";
import HeaderFactors from "./components/Factors/HeaderFactors";
import ExplainFactor from "./components/Factors/ExplainFactor";
import SpaceBetweenTables from "./components/Factors/SpaceBetweenTables";
import Table8 from "./components/Factors/Table/Table8";
import Table9 from "./components/Factors/Table/Table9";
import { useState } from "react";

const PageG8 = ({ reload }) => {
  const [koosheshEhsasiScore, SetKoosheshEhsasiScore] = useState("")
  const [koosheshJesmainScore, SetKoosheshJesmainScore] = useState("")
  return (
    <>
      <Page pageNumber={32}>
        <HeaderFactors
          numberFactors="عامل شانزدهم"
          titelFactors="کوشش احساسی"
          maxValue="40"
          jsValue={koosheshEhsasiScore}
        />
        <ExplainFactor
          text="تلاش و کوشش برای درك درست احساسات طرف مقابل وابراز احساسات صحیح ومتناسب با شرایط"
        />
        <Table8 koosheshEhsasiScore={koosheshEhsasiScore} SetKoosheshEhsasiScore={SetKoosheshEhsasiScore} reload={reload}/>
        <SpaceBetweenTables />
        <HeaderFactors
          numberFactors="عامل هفدهم"
          titelFactors="کوشش جسمانی"
          maxValue="40"
          jsValue={koosheshJesmainScore}
        />
        <ExplainFactor
          text="نوع، میزان و تکرار کوشش‌های جسمانی و حد سختی و صعوبت حرکات مورد نیاز برای انجام وظایف محوله"
        />
        <Table9 SetKoosheshJesmainScore={SetKoosheshJesmainScore} koosheshJesmainScore={koosheshJesmainScore} reload={reload}/>
      </Page>
    </>
  );
};

export default PageG8;
